const URL_RE = /https?:\/\/[^\s<>"']+/gi;
const TRAILING_PUNCT = /[.,!?;:'"]+$/;

function trimTrailingPunct(raw: string): string {
  return raw.replace(TRAILING_PUNCT, '');
}

/** Первая ссылка в тексте (для запроса превью сразу после отправки). */
export function firstUrl(text: string): string | null {
  const m = text.match(URL_RE);
  if (!m) return null;
  const url = trimTrailingPunct(m[0]);
  return url || null;
}

/** Текст, разбитый на обычные куски и ссылки — для рендера ссылок кликабельными. */
export function splitTextByUrls(text: string): { text?: string; url?: string }[] {
  const out: { text?: string; url?: string }[] = [];
  let lastIndex = 0;
  for (const match of text.matchAll(URL_RE)) {
    const start = match.index ?? 0;
    const url = trimTrailingPunct(match[0]);
    if (!url) continue;
    const end = start + url.length;
    if (start > lastIndex) out.push({ text: text.slice(lastIndex, start) });
    out.push({ url });
    lastIndex = end;
  }
  if (lastIndex < text.length) out.push({ text: text.slice(lastIndex) });
  return out;
}
